import axios from "axios";
import { cachedRead } from "../../../offline";

const base = `${process.env.REACT_APP_BACKEND_URL}/dispatch`;
const token = () => localStorage.getItem("token");
const headers = () => ({ headers: { Authorization: "Bearer " + token() } });

export const getMeta = () => axios.get(`${base}/meta`, headers());
export const saveSettings = body => axios.put(`${base}/settings`, body, headers());
export const getBoard = (from, days = 7) =>
  axios.get(`${base}/board?${new URLSearchParams({ from, days })}`, headers());
export const checkPlan = body => axios.post(`${base}/check`, body, headers());
export const createJob = body => axios.post(`${base}/jobs`, body, headers());
export const getJob = id => axios.get(`${base}/jobs/${id}`, headers());
export const updateJob = (id, body) => axios.put(`${base}/jobs/${id}`, body, headers());
export const deleteJob = id => axios.delete(`${base}/jobs/${id}`, headers());
export const createVehicle = body => axios.post(`${base}/vehicles`, body, headers());
export const updateVehicle = (id, body) => axios.put(`${base}/vehicles/${id}`, body, headers());
export const deleteVehicle = id => axios.delete(`${base}/vehicles/${id}`, headers());
export const updateStaff = (id, body) => axios.put(`${base}/staff/${id}`, body, headers());
export const emailPlans = body => axios.post(`${base}/plan/email`, body, headers());

// "Mein Tag" is read through the offline cache: on site without a connection the technician
// still sees the last loaded day (marked with `fromCache`).
export const getMyDay = ({ date, employee } = {}) => {
  const query = new URLSearchParams();
  if (date) query.set("date", date);
  if (employee) query.set("employee", employee);
  return cachedRead(`dispatch:my-day:${employee || "me"}:${date || "today"}`, () =>
    axios.get(`${base}/my-day?${query}`, headers())
  );
};

// A PDF opened as a link cannot send a header: the token goes in the query.
export const planPdfUrl = ({ from, employee }) =>
  `${base}/plan/pdf?${new URLSearchParams({
    from,
    ...(employee ? { employee } : {}),
    token: token() || ""
  })}`;
